module.exports = __webpack_public_path__ + "img/file-img-ppt.b6a538dd.jpg";